type IconProps = React.ComponentProps<'svg'>

export function LayersThree01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.31)">
        <path
          d="M20.4151 15.0208C20.7855 14.8358 21.2358 14.9854 21.421 15.3558C21.6061 15.7262 21.4555 16.1764 21.085 16.3616L11.4434 21.1829C11.3511 21.2291 11.1767 21.3239 10.9805 21.3607C10.8282 21.3892 10.6719 21.3892 10.5196 21.3607C10.3234 21.3239 10.149 21.2291 10.0567 21.1829L0.415118 16.3616C0.0446808 16.1764 -0.105953 15.7262 0.0791803 15.3558C0.264401 14.9854 0.714615 14.8358 1.08504 15.0208L10.7276 19.8411C10.7354 19.845 10.7432 19.8484 10.7501 19.8519C10.757 19.8484 10.7648 19.845 10.7725 19.8411L20.4151 15.0208Z"
          fill="currentColor"
        />
        <path
          d="M20.4151 10.0208C20.7855 9.83576 21.2358 9.98541 21.421 10.3558C21.6061 10.7262 21.4555 11.1764 21.085 11.3616L11.4434 16.1829C11.3511 16.2291 11.1767 16.3239 10.9805 16.3607C10.8282 16.3892 10.6719 16.3892 10.5196 16.3607C10.3234 16.3239 10.149 16.2291 10.0567 16.1829L0.415118 11.3616C0.0446809 11.1764 -0.105953 10.7262 0.0791803 10.3558C0.264401 9.98541 0.714615 9.83576 1.08504 10.0208L10.7276 14.8411C10.7354 14.845 10.7432 14.8484 10.7501 14.8519C10.757 14.8484 10.7648 14.845 10.7725 14.8411L20.4151 10.0208Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9805 0.0217966C11.1768 0.0586204 11.3511 0.153385 11.4434 0.199531L21.085 5.02082C21.3391 5.14788 21.5001 5.40767 21.5001 5.69172C21.4999 5.97556 21.3389 6.23469 21.085 6.36164L11.4434 11.1829C11.3511 11.2291 11.1767 11.3239 10.9805 11.3607C10.8282 11.3892 10.6719 11.3892 10.5196 11.3607C10.3234 11.3239 10.149 11.2291 10.0567 11.1829L0.415118 6.36164C0.161208 6.23469 0.000304487 5.97556 7.87154e-05 5.69172C7.87154e-05 5.40767 0.16107 5.14788 0.415118 5.02082L10.0567 0.199531C10.149 0.153385 10.3234 0.0586204 10.5196 0.0217966L10.6348 0.00519507C10.7501 -0.00546898 10.8664 0.000390747 10.9805 0.0217966ZM10.7276 1.54133L2.42586 5.69074L10.7276 9.84113C10.7354 9.84501 10.7432 9.84844 10.7501 9.85187C10.757 9.84844 10.7648 9.84501 10.7725 9.84113L19.0733 5.69074L10.7725 1.54133C10.7646 1.53736 10.7571 1.53312 10.7501 1.52961C10.7431 1.53312 10.7355 1.53736 10.7276 1.54133Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
